import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const IMAGES = [
  "https://images.unsplash.com/photo-1610374634235-b51ef357f905?w=1600&q=85",
  "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?w=1600&q=85",
  "https://images.pexels.com/photos/36237587/pexels-photo-36237587.jpeg?w=1600",
  "https://images.unsplash.com/photo-1578245600656-e8fe67a2b5f7?w=1600&q=85",
  "https://images.pexels.com/photos/36427283/pexels-photo-36427283.jpeg?w=1600",
  "https://images.unsplash.com/photo-1512790182412-b19e6d62bc39?w=1600&q=85",
  "https://images.unsplash.com/photo-1599912027667-755b68b4dd3b?w=1600&q=85",
  "https://images.pexels.com/photos/326259/pexels-photo-326259.jpeg?w=1600",
];

export default function Photography() {
  return (
    <main data-testid="photography-page" className="bg-black pt-32 pb-8">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-16">
        <motion.p {...reveal} className="overline mb-6">Work · Photography</motion.p>
        <motion.h1 {...reveal} className="font-display text-6xl md:text-8xl text-white leading-[0.95]">
          Photography <span className="italic text-[var(--gb-gold)]">/</span> Editorial
        </motion.h1>
        <motion.p {...reveal} className="text-white/65 text-base md:text-lg max-w-2xl mt-10 leading-relaxed">
          Considered stills for luxury brands, product launches and editorial features.
          Every frame is composed before the camera rolls.
        </motion.p>
      </section>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-1">
        {IMAGES.map((src, i) => (
          <motion.div
            {...reveal}
            key={i}
            data-testid={`photography-image-${i}`}
            className={`overflow-hidden group bg-black ${i % 5 === 0 ? "col-span-2 aspect-square" : "aspect-square"}`}
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]"
            />
          </motion.div>
        ))}
      </section>
    </main>
  );
}
